module.exports = __webpack_public_path__ + "8a2c89791e8e61ee1e5b9cd3ad97a22f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-21.png
// module id = 3215
// module chunks = 0